import Utils from './Utils.js';

const LOGIN_GRANT_TYPE = 'password';
const LOGIN_SCOPE = 'jobseeker';
const TOKEN_VERIFICATION_AUTH = 'Basic ZWZjOmVmY3NlY3JldA==';

class RequestBuilder {

  constructor(urlGenerator, locale) {

    this.urlGenerator = urlGenerator;
    this.locale = locale;

    this.language = getLanguage(locale);

  }

  getRegistrationFlowRequest(emailAddress) {

    if (Utils.stringIsInvalidOrEmpty(emailAddress)) {
      throw new Error('emailAddress is required and must be a non empty string');
    }

    return {
      url: this.urlGenerator.getRegistrationFlowUrl(emailAddress),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }

  }

  getRequestVerificationEmailRequest(emailAddress) {

    if (Utils.stringIsInvalidOrEmpty(emailAddress)) {
      throw new Error('emailAddress is required and must be a non empty string');
    }

    return {
      url: this.urlGenerator.getRequestVerificationEmailUrl(emailAddress),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }

  }

  getRequestResetPasswordEmailRequest(emailAddress) {

    if (Utils.stringIsInvalidOrEmpty(emailAddress)) {
      throw new Error('emailAddress is required and must be a non empty string');
    }

    return {
      url: this.urlGenerator.getRequestResetPasswordEmailUrl(emailAddress),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }

  }

  getRegistrationRequest(body) {

    return {
      url: this.urlGenerator.getRegistrationUrl(),
      body: body,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }

  }

  getTranslationsRequest(translationIds) {

    if (Utils.arrayIsInvalidOrEmpty(translationIds)) {
      throw new Error('translationIds is required and must be an array with at least one element');
    }

    let translation_requests = [];
    translationIds.forEach(function (translationId) {
      translation_requests.push({
        id: translationId
      });
    });

    return {
      url: this.urlGenerator.getTranslationsUrl(translationIds),
      body: {
        translation_requests: translation_requests
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': this.language
      }
    }

  }

  getPrivacyPolicyUrlRequest() {

    return {
      url: this.urlGenerator.getPrivacyPolicyUrl(),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }

  }

  getTermsAndConditionsUrlRequest() {

    return {
      url: this.urlGenerator.getTermsAndConditionsUrl(),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }

  }

  getAuthenticationRequest(username, password) {

    if (Utils.stringIsInvalidOrEmpty(username)) {
      throw new Error('username is required and must be a non empty string');
    }
    if (Utils.stringIsInvalidOrEmpty(password)) {
      throw new Error('password is required and must be a non empty string');
    }

    return {
      url: this.urlGenerator.getAuthenticationUrl(),
      body: {
        grant_type: LOGIN_GRANT_TYPE,
        scope: LOGIN_SCOPE,
        username: username,
        password: password
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': TOKEN_VERIFICATION_AUTH
      }
    }

  }

  getAccessTokenWithOpenIdTokenRequest(token) {

    if (Utils.stringIsInvalidOrEmpty(token)) {
      throw new Error('token is required and must be a non empty string');
    }

    return {
      url: this.urlGenerator.getAccessTokenWithOpenIdTokenUrl(token),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }

  }

  getLinkAccountRequest(requestToken, email, password) {

    if (Utils.stringIsInvalidOrEmpty(requestToken)) {
      throw new Error('requestToken is required and must be a non empty string');
    }
    if (Utils.stringIsInvalidOrEmpty(email)) {
      throw new Error('email is required and must be a non empty string');
    }
    if (Utils.stringIsInvalidOrEmpty(password)) {
      throw new Error('password is required and must be a non empty string');
    }

    return {
      url: this.urlGenerator.getLinkAccountUrl(),
      body: {
        request_token: requestToken,
        email: email,
        password: password,
        locale: this.locale
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }

  }

  getRegisterRequest(requestToken, email) {

    if (Utils.stringIsInvalidOrEmpty(requestToken)) {
      throw new Error('requestToken is required and must be a non empty string');
    }

    let body = {
      request_token: requestToken,
      locale: this.locale
    };

    if (email) {
      if (Utils.stringIsInvalidOrEmpty(email)) {
        throw new Error('email is required and must be a non empty string');
      } else {
        body.email = email;
      }
    }

    return {
      url: this.urlGenerator.getRegisterUrl(),
      body: body,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }

  }

}

let getLanguage = function (locale) {

    return locale === undefined ? null : locale.split('_')[0];

};

export default RequestBuilder;



// WEBPACK FOOTER //
// ./src/library/services/RequestBuilder.js